<template>
<mdb-dropdown>
  <mdb-dropdown-toggle slot="toggle" class="switch-bar pl-2 pr-0">
    <i class="fas fa-guide"></i>
    <label>{{ $t('menu.documentMgm') }}</label>
  </mdb-dropdown-toggle>
  <mdb-dropdown-menu class="doc-dropdown">
    <mdb-dropdown-item
      v-for="(listdoc, index) in dropdownDownload"
      :key="index"
      @click="downloadDoc(listdoc)">
      <img :src="`${listdoc.pic}`"  alt="" width="20" height="20">
      <label class="ml-2">{{ listdoc.name }}</label>
    </mdb-dropdown-item>
  </mdb-dropdown-menu>
</mdb-dropdown>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import DocumentModule from '@/store/modules/Document';
import thai from '@/assets/images/thailand.png';
import usa from '@/assets/images/usa.png';

@Component
export default class DocDownload extends Vue {
  dropdownDownload = [
    {
      name: 'คู่มือภาษาไทย',
      filename: 'AMBSlotAGENT_V.TH',
      value: 'documentTh',
      pic: thai,
    },
    {
      name: 'User Manual',
      filename: 'AMBSlotAGENT_V.ENG',
      value: 'documentEn',
      pic: usa,
    },
  ];

  DocumentInstance = getModule(DocumentModule, this.$store);

  async downloadDoc(name) {
    const fileName = {
      documentName: name.value,
    };
    await this.DocumentInstance.DownloadDocument(fileName);
    const fileURL = window.URL.createObjectURL(new Blob([this.DocumentInstance.dataFile.dataFile]));
    const fileLink = document.createElement('a');
    fileLink.href = fileURL;
    fileLink.setAttribute('download', `${name.filename}.pdf`);
    document.body.appendChild(fileLink);
    fileLink.click();
  }
}
</script>

<style lang="scss" scoped>
.switch-bar label {
  cursor: pointer;
}
</style>
